<template>
  <div class="page page-shell">
    <van-nav-bar :title="$t('setting.bank_info')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="content">
      <div class="hero-card">
        <div class="hero-badge">{{ $t("my.withdraw1") }}</div>
        <!-- <div class="hero-title">{{ $t("setting.bank_info") }}</div> -->
        <div class="hero-desc">{{ $t("setting.bind_bank") }}</div>
      </div>

      <div v-if="is_bind" class="info-card">
        <div class="info-row">
          <span class="label">真實姓名</span>
          <span class="value">{{ bankInfo.username || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">銀行代碼</span>
          <span class="value">{{ bankInfo.bank_code || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">銀行帳號</span>
          <span class="value">{{ bankInfo.bankid || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">銀行分行</span>
          <span class="value">{{ bankInfo.branch_name || "-" }}</span>
        </div>
      </div>

      <div v-else class="empty-card">
        <div class="empty-icon">+</div>
        <div class="empty-title">{{ $t("setting.add_bank") }}</div>
        <!-- <div class="empty-desc">{{ $t("setting.bind_bank_tip") }}</div> -->
      </div>

      <van-button v-if="!is_bind" class="action-btn" type="primary" @click="toBindCard()">
        {{ is_bind ? $t("setting.add_bank") : $t("setting.add_bank") }}
      </van-button>
    </div>
    <withdrawal-password-gate v-model="passwordSetupOpen" :is-setup="true" @complete="finishPasswordSetup" @cancel="cancelPasswordSetup" />
  </div>
</template>

<script>
import withdrawalPassword from "../../common/withdrawal-password"
export default {
  mixins: [withdrawalPassword],
  data() {
    return {
      is_bind: false,
      bankInfo: {},
      userInfo: {},
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserBankInfo() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
            this.bankInfo = res.data.info || {};
          } else {
            this.is_bind = false;
            this.bankInfo = {};
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    toBindCard() {
      this.ensureWithdrawalPassword(() => this.$router.push({ path: "/BindCard" }));
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.less";

.page-shell {
  min-height: 100%;
  background: #0b0b0d;
}

.content {
  padding: 16px;
}

.hero-card {
  padding: 20px;
  border-radius: 18px;
  border: 1px solid #444;
  background: linear-gradient(to bottom right, #33251a, #1b1435);
  margin-bottom: 16px;
}

.hero-badge {
  display: inline-flex;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 24px;
}

.hero-title {
  margin-top: 12px;
  color: #f4c57d;
  font-size: 36px;
  font-weight: 700;
}

.hero-desc {
  margin-top: 8px;
  color: #ddd;
  font-size: 24px;
  line-height: 1.6;
}

.info-card,
.empty-card {
  padding: 18px;
  border-radius: 18px;
  border: 1px solid #2a2a2a;
  background: #141419;
}

.info-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.label {
  color: #8f93a1;
  font-size: 24px;
}

.value {
  color: #fff;
  font-size: 30px;
  word-break: break-all;
}

.empty-card {
  text-align: center;
}

.empty-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 12px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #f4c57d;
  background: rgba(244, 197, 125, 0.1);
  border: 1px solid rgba(244, 197, 125, 0.2);
}

.empty-title {
  color: #fff;
  font-size: 30px;
  font-weight: 700;
}

.empty-desc {
  margin-top: 8px;
  color: #8f93a1;
  font-size: 24px;
  line-height: 1.6;
}

.action-btn {
  margin-top: 18px;
  width: 100%;
  height: 52px;
  border: none;
  border-radius: 18px;
  color: #111;
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(to right, #f4c57d, #f5a452);
}
</style>
